import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useJobProvider } from "../../../../Providers/Consultant/Jobs";
import CustomTable from "../../../../Components/Table";
import { useNavigate } from "react-router-dom";

const headCells = [
  {
    id: "Name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "StartDate",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "Client",
    numeric: false,
    disablePadding: false,
    label: "Client",
  },
  {
    id: "JobDescription",
    numeric: false,
    disablePadding: false,
    label: "Job Description",
  },
];

export default function ListOfJobs({ setJobId }) {
  const { jobs, fetchJobsForConsultant } = useJobProvider();

  React.useEffect(() => {
    fetchJobsForConsultant();
  }, []);

  const navigate = useNavigate()

  const CustomRow = ({ row }) => {
    return (
      <TableRow
        tabIndex={-1}
        key={row?.job.id}
        className="cursor-pointer"
        onClick={() => {
          navigate(`/dashboard/my-jobs/${row?.job.id}`)
        }}
      >
        <TableCell
          className="truncate max-w-[250px]"
          component="th"
          scope="row"
          padding="none"
        >
          {row?.job.name}
        </TableCell>
        <TableCell align="left">{row?.job?.start_date}</TableCell>
        <TableCell align="left">
          {`${row?.vendor?.company}`.trim()}
        </TableCell>
        <TableCell className="truncate max-w-[250px]" align="left">{row?.job?.description}</TableCell>
      </TableRow>
    )
  }

  return (
    <div className="mt-8">
      <CustomTable
        title="Jobs"
        headCells={headCells}
        rows={jobs}
        CustomRow={CustomRow}
      />
    </div>
  );
}
